import React from 'react';
import Text from 'shared/components/Text/Text';
import { CheckIcon } from 'shared/components/icons';
import { useTheme } from 'styled-components';
import Button from 'shared/components/Button/Button';
import ChevronRight from 'shared/components/icons/ChevronRight';
import { useTranslation } from 'react-i18next';
import { handleFocusedKeyPress } from 'shared/utils/handleFocusedKeypress';
import { AddressCardContent, AddressCardWrapper } from './AddressCard.styles';

interface AddressCardProps {
  address: string;
  isSelected: boolean;
  actionRequired: boolean;
  onSelectAddress: () => void;
}

export function AddressCard({
  address,
  isSelected,
  actionRequired,
  onSelectAddress,
}: AddressCardProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'accountMenu.addressCard' });
  const theme = useTheme();

  return (
    <AddressCardWrapper
      $isSelected={isSelected}
      onClick={onSelectAddress}
      tabIndex={0}
      onKeyUp={(e) => handleFocusedKeyPress(e, onSelectAddress)}
    >
      <AddressCardContent>
        <Text as="h3" $lineClamp={1} color={theme.colors.textSecondaryGrey90}>
          {address}
        </Text>
        <Text
          as="sub"
          $fontSize={14}
          $fontWeight={400}
          color={
            actionRequired
              ? theme.colors.chartChartMagentaAccent1100
              : theme.colors.textSecondarySubtleGrey80
          }
        >
          {actionRequired ? t('actionRequired') : t('systemActive')}
        </Text>
      </AddressCardContent>
      {isSelected ? (
        <CheckIcon color={theme.colors.iconIconPrimarySecondary1100} dimensions="16" />
      ) : (
        <Button styleVariant="tertiary" label={t('view')} Icon={ChevronRight} iconRight />
      )}
    </AddressCardWrapper>
  );
}

export default AddressCard;
